<template>
  <div class="md-size-100">
		<el-form-item v-if="elUi" :label="label">
			<el-select
				v-model="taxStation"
				placeholder="Search Tax Station"
				filterable
				clearable
				size="large"
				:style="elUiStyle"
			>
				<el-option
					v-for="item in taxStations"
					:key="item.id"
					:label="item.name"
					:value="item.id"
				/>
			</el-select>
		</el-form-item>

    <div v-if="!elUi" class="md-layout-item" :class="mdClass">
			<label v-if="label">{{ label }}</label>
			<v-select
				:disabled="disabled"
				v-model="taxStation"
				placeholder="Search Tax Station"
				:reduce="aet => aet.id"
				label="name"
				:options="taxStations">
			</v-select>
		</div>
  </div>
</template>

<script>
	import { getItemsByEndPoint, notification } from "@/lib/utils";
	import { FormItem, Select, Option } from "element-ui";

	export default {
		name: "tax-stations-master",

		components: {
			ElFormItem: FormItem,
			[Select.name]: Select,
			[Option.name]: Option
		},

		props: {
			disabled: {
				type: Boolean,
				default: false
			},

			currentValue: {
				type: [Number, String],
				default: ''
			},

			modelName: {
				type: String,
				default: ''
			},

			label: {
				type: String,
				default: ''
			},

			mdClass: {
				type: String,
				default: 'md-size-100 md-small-size-100'
			},

			regionId: {
				type: Number,
				default: 0
			},

			showOptionAll: {
				type: Boolean,
				default: false
			},

			elUi: {
				type: Boolean,
				default: false
			},

			elUiStyle: {
				type: String,
				default: "display: block;"
			}
		},

		data() {
			return {
				taxStations: []
			}
		},

		computed: {
			taxStation: {
				get () {
					const item = this.taxStations.find(item => item.id == this.currentValue);
					return (item && item.id) || '';
				},
				set (value) {
					this.$emit(`update:${this.modelName}`, value);
				}
			}
		},

		methods: {
			getTaxStations() {
				const endPoint = "tax/offices";
				const order = "name";
				const filters = [];
				if(this.regionId) {
					this.taxStation = null;
					filters.push(
						{
							field: 'region_id',
							value: this.regionId
						}
					);
				}
				getItemsByEndPoint(endPoint, order, this.$http, filters)
					.then(data => {
						this.taxStations = data.list;

            if(this.showOptionAll) {
              this.taxStations.unshift({
                name: "All Offices",
                id: "all-offices",
                region_id: "all-offices"
              })
            }
						this.$emit('update:taxStations', this.taxStations);
					})
					.catch((err) => {
						notification(this, err.message, 'pan_tool', 'danger');
					});
			}
		},

		created(){
			this.$watch('regionId', () => {
				this.getTaxStations();
			}, { immediate:true });
		}
	};
</script>
